import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-navy">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-12 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1586191552066-d52dd1e3af86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="truck" className="absolute inset-0 w-full h-full object-cover opacity-55" />
        <div className="absolute inset-0 bg-navy/60" />
        <div className="relative z-10 flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-primary flex items-center justify-center font-heading font-extrabold text-white text-2xl">K3</div>
          <div>
            <div className="font-heading font-bold text-white text-xl">K3 REPAIR SYSTEM</div>
            <div className="text-sm text-slate-300">Commercial Vehicle Repair & Project Management</div>
          </div>
        </div>
        <div className="relative z-10 text-slate-300 max-w-md">
          <h2 className="font-heading text-3xl font-bold text-white mb-3">Kelola perbaikan armada niaga secara terpusat.</h2>
          <p className="text-sm">Kartu Proyek, master customer & kendaraan, audit history — dalam satu sistem yang rapi.</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white p-8 rounded-2xl shadow-xl">
          <div className="lg:hidden flex items-center gap-2 justify-center mb-2">
            <div className="h-10 w-10 rounded-lg bg-primary flex items-center justify-center font-heading font-extrabold text-white">K3</div>
            <span className="font-heading font-bold text-navy">K3 REPAIR SYSTEM</span>
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold text-navy">Masuk</h1>
            <p className="text-sm text-muted-foreground">Silakan masuk ke akun Anda.</p>
          </div>
          {error && <div data-testid="login-error" className="text-sm text-primary bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="nama@email.com" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Kata Sandi</Label>
            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
          </div>
          <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full bg-primary hover:bg-red-700 h-10">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Masuk"}
          </Button>
          <div className="text-center">
            <Link to="/forgot-password" className="text-xs text-muted-foreground hover:text-primary" data-testid="forgot-link">Lupa kata sandi?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
